import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { reverseKebabCase } from "../utilities/helper";

const AnchorLinksContext = createContext();

export const useAnchorLinks = () => useContext(AnchorLinksContext);

export const AnchorLinksProvider = ({ children }) => {
  const [anchorLinks, setAnchorLinks] = useState([]);
  const [collectStartingIndex, setCollectStartingIndex] = useState(null);

  const startCollectingAnchorLink = useCallback((index = null) => {
    setCollectStartingIndex(index);
  }, []);

  // 1. window.anchorLinks has filter function
  // 2. Check window.anchorlinks does not already contain a link with the same id as the current link
  // 3. push the id and title to the window.anchorLinks array
  const collectAnchorLinks = useCallback(
    (id, title, index = null) => {
      //skipping block before the starting index
      // console.log(id, title, index, collectStartingIndex);
      if (!collectStartingIndex || collectStartingIndex > index) return;
      setAnchorLinks((prevLinks) => {
        // Prevent duplicate ids
        if (prevLinks.some((link) => link[0] === id)) {
          console.error(`Duplicate anchor link id: ${id}`, title);
          return prevLinks;
        }
        return [...prevLinks, [id, title]];
      });
    },
    [collectStartingIndex]
  );

  return <AnchorLinksContext.Provider value={{ anchorLinks, collectAnchorLinks, startCollectingAnchorLink }}>{children}</AnchorLinksContext.Provider>;
};

/**
 * This is a custom hook from this context
 * @param {?string} title
 * @param {?string} anchor
 * @param {?number} index
 */
export const useCollectAnchorLinks = (title, anchor, index) => {
  const anchorLinksContext = useAnchorLinks();
  const collectAnchorLinks = anchorLinksContext?.collectAnchorLinks ?? null;

  useEffect(() => {
    if (typeof collectAnchorLinks === "function" && anchor && !isNaN(index)) {
      collectAnchorLinks(anchor, title ?? reverseKebabCase(anchor), index);
    }
  }, [collectAnchorLinks, title, anchor, index]);
};
